
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getData"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "0933eca69d769af186b7.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			